import { HttpClient, HttpParams } from '@angular/common/http';
import { text } from '@fortawesome/fontawesome-svg-core';
import { data } from 'jquery';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Form } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  baseApiUrl = 'https://file.io';
  arr = [
    'items1',
    'items2',
    'items3',
    'items4',
    'items5',
    'items6',
    'items7',
    'items8',
  ];

  constructor(private http: HttpClient) {}

  public parentInitEvent: EventEmitter<void> = new EventEmitter<void>();


  //user-timezone update

  updateTimezone(timezone:any): Observable<any> {
    const url = environment.apiURL + `api/updateTimezone`;

    const params = new HttpParams().set('timezone', timezone);
    return this.http.put(url, {}, {
      params: params,
      responseType: 'text'
    });
  }


  //creatics homepage loggedOut

  getCreaticsHomepage(): Observable<any> {
    const url = environment.apiURL + 'api/creatics/home-page';
    return this.http.get(url);
  }

  updateCreaticsHomepage(formData: FormData, data: string): Observable<any> {
    const url = environment.apiURL + `api/creatics/home-page/edit`;

    let params: HttpParams = new HttpParams();
    params = params.set('creaticsHomePageRequest', data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text',
    });
  }

  //creatics homepage loggedIn

  getCreaticsHomepageLoggedIn(): Observable<any> {
    const url = environment.apiURL + 'api/creatics/login/home-page';
    return this.http.get(url, {
      withCredentials: true,
    });
  }

  updateCreaticsHomepageLoggedIn(
    formData: FormData,
    data: string
  ): Observable<any> {
    const url = environment.apiURL + `api/creatics/login/home-page/edit`;

    let params: HttpParams = new HttpParams();
    params = params.set('creaticsLoginHomePageRequest', data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text',
      withCredentials: true,
    });
  }

  //creatics About page

  getCreaticsAboutpage(): Observable<any> {
    const url = environment.apiURL + 'api/creatics/about-page';
    return this.http.get(url);
  }

  updateCreaticsAboutpage(formData: FormData, data: string): Observable<any> {
    const url = environment.apiURL + `api/creatics/about-page/edit`;

    let params: HttpParams = new HttpParams();
    params = params.set('creaticsAboutPageRequest', data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  // updateCreaticsAboutpage(formData: FormData, data: string): Observable<any> {
  //   const url = environment.apiURL + `api/creatics/about-page/edit`;

  //   let params: HttpParams = new HttpParams();
  //   params = params.set('creaticsAboutPageRequest', data);

  //   return this.http.post(url, formData, {
  //     params: params,
  //     responseType: 'text',
  //   });
  // }

  //copyright
  getCopyright(): Observable<any> {
    const url = environment.apiURL + 'api/copyright/details';
    return this.http.get(url);
  }

  updateCopyright(data: any): Observable<any> {
    const url = environment.apiURL + `api/copyright/details/edit`;

    const headers = { 'content-type': 'application/json' };

    return this.http.post(url, data, {
      responseType: 'text',
      headers: headers,
    });
  }
  //Cinejoy Homepage
  getCinejoyHomepage(): Observable<any> {
    const url = environment.apiURL + 'api/cinejoy/home-page/info';
    return this.http.get(url);
  }

  updateCinejoyHomepage(formData: FormData, data: string): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/home-page/details`;

    // const formData:any = new FormData();
    // formData.append('home-page', imageFile);
    // formData.append('event-list', eventImageFile);

    let params: HttpParams = new HttpParams();
    params = params.set('CinejoyHomePageRequest', data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text',
    });
  }

  //Cinejoy About
  getCinejoyAboutPage(): Observable<any> {
    const url = environment.apiURL + 'api/cinejoy/about-page/info';
    return this.http.get(url);
  }

  updateCinejoyAboutPage(formData: FormData, data: string): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/about-page/details`;

    // const formData:any = new FormData();
    // formData.append('home-page', imageFile);
    // formData.append('event-list', eventImageFile);

    let params: HttpParams = new HttpParams();
    params = params.set('CinejoyAboutPageRequest', data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text',
    });
  }


  // Returns an observable
  upload(file: any): Observable<any> {
    // Create form data
    const formData = new FormData();

    // Store form name as "file" with file data
    formData.append('file', file, file.name);

    // Make http post request over api
    // with formData as req
    return this.http.post(this.baseApiUrl, formData);
  }

  getMovieDuplicate(movieId, movieTitle: any): Observable<any> {
    const url =
      environment.apiURL +
      `api/check-duplicate-movie-title?movieId=${movieId}&movieTitle=${movieTitle}`;
    return this.http.get(url);
  }

  getFetchAllMovies(): Observable<any> {
    const url = environment.apiURL + `api/hitmaker/fetch-all-movie-titles`;

    return this.http.get(url);
  }
  PostHitmakerMovie(title: any, description: any, file: any): Observable<any> {
    const url =
      environment.apiURL +
      `api/add/hitmaker/homepage/details?title=${title}&description=${description}`;
    const formData = new FormData();
    formData.append('bannerImage', file);

    let params: HttpParams = new HttpParams();
    params = params.set('title', title);
    params = params.set('description', description);

    return this.http.post(url, formData);
  }
  PostHitmakerDescription(
    descText1: any,
    descText2: any,
    descText3: any
  ): Observable<any> {
    const url = environment.apiURL + `api/add-hitmaker-description`;
    return this.http.post(url, {
      contestResultDescription: descText1,
      drawingsResultDescription: descText2,
      specialPremiereDescription: descText3,
    });
  }

  postHitmakerMain(title: any, description: any, file: any) {
    const url = environment.apiURL + `api/add/hitmaker/homepage/details`;
    const formData = new FormData();
    formData.append('movieTitle', title);
    formData.append('movieDesc', description);
    formData.append('movieImage', file);
    return this.http.post(url, formData);
  }

  postHimakerMoviePage(
    movieTitle: any,
    movieDesc: any,
    stage1Name: any,
    stage2Name: any,
    stage3Name: any,
    stage4Name: any,
    stage5Name: any,
    posterImagefile: any,
    posterThumbnailImagefile: any,
    stage1ThumbnailImg: any,
    stage2ThumbnailImg: any,
    stage3ThumbnailImg: any,
    stage4ThumbnailImg: any,
    stage5ThumbnailImg: any
  ) {
    const url =
      environment.apiURL +
      `api/hitmaker/add/movie?movieTitle=${movieTitle}&movieDesc=${movieDesc}&stage1Name=${stage1Name}&stage2Name=${stage2Name}&stage3Name=${stage3Name}&stage4Name=${stage4Name}&stage5Name=${stage5Name}`;
    const formData = new FormData();
    formData.append('posterImage', posterImagefile);
    formData.append('movieThumbnailImage', posterThumbnailImagefile);
    formData.append('stage1ThumbnailImage', stage1ThumbnailImg);
    formData.append('stage2ThumbnailImage', stage2ThumbnailImg);
    formData.append('stage3ThumbnailImage', stage3ThumbnailImg);
    formData.append('stage4ThumbnailImage', stage4ThumbnailImg);
    formData.append('stage5ThumbnailImage', stage5ThumbnailImg);

    // formData.append('movieImage', file);
    let params: HttpParams = new HttpParams();
    params = params.set('movieTitle', movieTitle);
    params = params.set('movieDesc', movieDesc);
    params = params.set('stage1Name', stage1Name);
    params = params.set('stage2Name', stage2Name);
    params = params.set('stage3Name', stage3Name);
    params = params.set('stage4Name', stage4Name);
    params = params.set('stage5Name', stage5Name);

    return this.http.post(url, formData);
  }

  // postNewContestPage(
  //   userId: any,
  //   contestcategory: any,
  //   contestname: any,
  //   contestouterimagerotationdeg: any,
  //   contestinnerimagerotationdeg: any,
  //   contestlargedesctitle: any,
  //   contestsmalldesc: any,
  //   contestvotingdesc: any,
  //   contestlargedesc: any,
  //   movieId: any,
  //   currency: any,
  //   conteststartdate: any,
  //   postNewContestPageRequest: any
  // ) {
  //   let url =
  //     environment.apiURL +
  //     `api/users/${userId}/account/addnewcontest?contestcategory=${contestcategory}&contestname=${contestname}&contestouterimagerotationdeg=0&contestinnerimagerotationdeg=0&contestsmalldesc=${contestsmalldesc}&contestlargedesctitle=${contestlargedesctitle}&contestvotingdesc=${contestvotingdesc}&contestlargedesc=${contestlargedesc}&conteststartdate=${conteststartdate}`;
  //   if (movieId) {
  //     url = url + `&movieId=${movieId}`;
  //   }
  //   if (currency) {
  //     url = url + `&currency=${currency}`;
  //   }

  //   console.log(url);
  //   console.log(postNewContestPageRequest);

  //   return this.http.post(url, postNewContestPageRequest);
  // }
  getViewMovieDetails(movieId: any): Observable<any> {
    const url =
      environment.apiURL + `api/hitmaker/fetch-movie-details?movieId=${movieId}`;

    return this.http.get(url);
  }
  postOnModifyMovie(id: any, title: any, description: any, file: any, stage1: any, stage2: any, stage3: any, stage4: any, stage5: any) {
    const url = environment.apiURL + `api/hitmaker/modify-a-movie`;
    const formData = new FormData();
    formData.append('movieId', id);
    formData.append('movieTitle', title);
    formData.append('movieDesc', description);
    formData.append('movieImageModified', file);
    formData.append('stage1ThumbnailImage', stage1);
    formData.append('stage2ThumbnailImage', stage2);
    formData.append('stage3ThumbnailImage', stage3);
    formData.append('stage4ThumbnailImage', stage4);
    formData.append('stage5ThumbnailImage', stage5);

    return this.http.post(url, formData);
  }
  postDeleteMovie(movieId) {
    const url = environment.apiURL + `api/delete-a-movie`;
    const formData = new FormData();
    formData.append('movieId', movieId);
    return this.http.post(url, formData);
  }
  getFetchUserAndProducer() {
    const url = environment.apiURL + `api/fetch-users-and-isproducer`;
    return this.http.get(url);
  }

  getProducers(movieId) {
    const url =
      environment.apiURL +
      `api/hitmaker/fetch-producers-for-movie?movieId=${movieId}`;
    return this.http.get(url);
  }
  getHitmakerMoviePage(movieId: any): Observable<any> {
    const url = environment.apiURL + `api/hitmaker/movie/${movieId}/stages`;
    return this.http.get(url);
  }
  getHitmakerMain() {
    const url = environment.apiURL + `api/hitmaker`;
    return this.http.get(url);
  }
  getUserId(): Observable<any> {
    const url = environment.apiURL + `cinejoy/api/showcases`;
    return this.http.get(url);
  }
  postToggleGrant(userId: any, movieId: any, action: any) {
    const url = environment.apiURL + `api/toggle-producer-privilege`;
    const formData = new FormData();
    formData.append('userId', userId);
    formData.append('movieId', movieId);
    formData.append('action', action);
    return this.http.post(url, formData);
  }
  getCategoryInfo(userId: any): Observable<any> {
    const url =
      environment.apiURL + `/users/${userId}/account/getcategorymappinginfo`;
    return this.http.get(url);
  }

  getPrizeCategories(): Observable<any> {
    const url = environment.apiURL + `api/contests/getPrizeCategories`;
    return this.http.get(url);
  }
  getContestInfo(userId: any): Observable<any> {
    const url = environment.apiURL + `/users/${userId}/account/getcontestsinfo`;
    return this.http.get(url);
  }
  getContestNames(): Observable<any> {
    const url = environment.apiURL + `api/fetch/contest-names`;
    return this.http.get(url);
  }
  getDrawWinners(contestId: any, prize1: any, prize2: any, prize3: any) {
    const url =
      environment.apiURL +
      `api/fetchWinnersForContest?contestId=${contestId}&prizes=${prize1}&prizes=${prize2}&prizes=${prize3}`;
    return this.http.get(url);
  }
  getDrawingInfo(userId: any): Observable<any> {
    const url = environment.apiURL + `/users/${userId}/account/getdrawingsinfo`;
    return this.http.get(url);
  }
  getDrawingInfo1(userId: any): Observable<any> {
    const url =
      environment.apiURL + `api/users/${userId}/account/fetch/drawingsinfo`;
    return this.http.get(url);
  }
  getContestantMap(userId: any): Observable<any> {
    const url =
      environment.apiURL +
      `/users/${userId}/account/getconteststocontestantmap`;
    return this.http.get(url);
  }
  getContestantInfo(userId: any): Observable<any> {
    const url =
      environment.apiURL + `api/users/${userId}/account/getcontestantsinfo`;
    return this.http.get(url);
  }
  getAllUsersContest(contestId: any): Observable<any> {
    const url =
      environment.apiURL + `api/fetchUsersProfileForContest?contestId=${contestId}`;
    return this.http.get(url);
  }
  getUsersContest(contestId: any): Observable<any> {
    const url =
      environment.apiURL +
      `api/fetchContestantsForContest?contestId=${contestId}`;
    return this.http.get(url);
  }
  getContestRating(userId: any, contestId: any) {
    const url =
      environment.apiURL + `users/${userId}/account/contest/${contestId}`;
    return this.http.get(url);
  }
  getUpdatedMovie(contestId: any) {
    const url =
      environment.apiURL + `api/fetchContestDetails?contestId=${contestId}`;
    return this.http.get(url);
  }
  getFanUpdates() {
    const url = environment.apiURL + `api/fetch-all-fanupdate/titles`;
    return this.http.get(url);
  }
  getContestRating1(userId: any, contestId: any) {
    const url =
      environment.apiURL + `users/${userId}/account/contest/${contestId}`;
    return this.http.get(url);
  }
  postToggleContest(contestID: any) {
    const url = environment.apiURL + `api/toggle-hide-a-contest`;
    const formData = new FormData();
    formData.append('contestId', contestID);

    return this.http.post(url, formData);
  }
  postAddContestanToContest(
    contestantType: any,
    userId: any,
    userProfileId:any,
    firstName: any,
    lastName: any,
    contestId: any,
    contestantDescription: any,
    contestantVideo: any,
    contestantImage: any,
    sequence: any
  ) {
    const url =
      environment.apiURL + `api/users/${userId}/account/addcontestantocontest`;
    const formData = new FormData();
    formData.append('contestantType', contestantType);
    formData.append('userProfileId ', userProfileId);
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('contestId', contestId);
    formData.append('contestantDescription', contestantDescription);
    formData.append('contestantVideo', contestantVideo);
    formData.append('contestantImage', contestantImage);
    formData.append('sequence', sequence);

    return this.http.post(url, formData);
  }
  postUpdateContest(
    contestId:any,
    name:any,
    mainDescTitle:any,
    mainDesc:any,
    whatToDoDesc:any,
    votingDesc:any,
    startDate:any,
    currency:any,
    innerImage:any,
    outerImage: any

  ) {
    let url =
      environment.apiURL + `api/modifyContestDetails`;
      const formData = new FormData();
      formData.append('contestId', contestId);
      formData.append('name ', name);
      formData.append('mainDescTitle', mainDescTitle);
      formData.append('mainDesc', mainDesc);
      formData.append('votingDesc', votingDesc);
      formData.append('whatToDoDesc', whatToDoDesc);
      formData.append('startDate', startDate);
      if(currency){

        formData.append('currency', currency);
      }
      formData.append('innerImage', innerImage);
      formData.append('outerImage', outerImage);
    return this.http.post(url, formData );
  }

  postFeaturedContest(contestID: any) {
    const url = environment.apiURL + `api/toggle-featured-a-contest`;
    const formData = new FormData();
    formData.append('contestId', contestID);

    return this.http.post(url, formData);
  }
  postAddPrizeToContest(
    userId: any,
    contestID: any,
    category: any,
    description: any,
    items: any
  ) {
    const url =
      environment.apiURL + `users/${userId}/account/addprizetocontest`;
    const formData = new FormData();
    formData.append('contestId', contestID);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('items', items);

    return this.http.post(url, formData,items);
  }
  postModifyAddPrizeToContest(
    userId: any,
    prizeId:any,
    contestID: any,
    category: any,
    description: any,
    items: any
  ) {
    const url =
      environment.apiURL + `users/${userId}/account/updatecontestprize`;
    const formData = new FormData();
    formData.append('prizeId', prizeId);
    formData.append('contestId', contestID);
    formData.append('category', category);
    formData.append('description', description);
    formData.append('items', items);

    return this.http.post(url, formData,items);
  }
  postDeletePrize
  (
    userId: any,
    prizeId:any,
    contestID: any,
  ){
    const url =
      environment.apiURL + `api/users/${userId}/account/deletecontestprize`;
    const formData = new FormData();
    formData.append('prizeId', prizeId);
    formData.append('contestId', contestID);


    return this.http.post(url, formData);
  }
  getMoviesInfo(): Observable<any> {
    const url = environment.apiURL + `api/movies`;
    return this.http.get(url);
  }
  getFanUpdateTitles(): Observable<any> {
    const url = environment.apiURL + `api/fetch-all-fanupdate/titles`;
    return this.http.get(url);
  }

  getDrawingRaffle(contestId: any): Observable<any> {
    const url =
      environment.apiURL + `api/contests/${contestId}/getPrizesInContest`;
    return this.http.get(url);
  }
  postDeletefanUpdate(fanUpdateId: any) {
    const url = environment.apiURL + `api/delete-a-fanupdate`;
    const formData = new FormData();
    formData.append('fanUpdateId', fanUpdateId);

    return this.http.post(url, formData);
  }
  postFanUpdate(title: any, description: any, file: any) {
    const url = environment.apiURL + `api/add-new-fanupdate`;
    const formData = new FormData();
    formData.append('fanUpdateTitle', title);
    formData.append('fanUpdateDesc', description);
    formData.append('fanUpdateImage', file);
    return this.http.post(url, formData);
  }
  postRemoveContestant(userId: any, competitorId: any, contestId: any) {
    const url =
      environment.apiURL +
      `/users/${userId}/account/removeContestantFromContest`;

    const formData = new FormData();
    formData.append('competitorId', competitorId);
    formData.append('contestId', contestId);
    return this.http.post(url, formData);
  }

  fetchUser(name: any): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('term', name);
    const url = environment.apiURL + 'api/userProfiles/fetchUserProfiles'
    return this.http.get(url, {
      withCredentials: true,
      params: params
    });
  }
  getTeamDetails(): Observable<any> {
    const url = environment.apiURL + `api/creatics/team/list`;
    return this.http.get(url);
  }

  updateHomepage(formData: FormData): Observable<any> {
    const url = environment.apiURL + `api/creatics/team/home-details`;

    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  addTeamMember(formData: FormData): Observable<any> {
    const url = environment.apiURL + `api/creatics/team/add-member`;

    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  updateTeamMember(user_id, id, formData: FormData): Observable<any> {
    const url = environment.apiURL + `api/users/${user_id}/account/modifymember/${id}`;

    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  deleteTeamMember(user_id, id): Observable<any> {
    const url = environment.apiURL + `api/users/${user_id}/account/deletemember/${id}`;

    return this.http.delete(url);
  }

  //Spotlights

  addSpotlight(formData: FormData): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/spotlight/event`;

    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  deleteSpotlight(id): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/spotlight/event/${id}`;

    return this.http.delete(url);
  }

  editSpotlight(formData: FormData): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/spotlight/event/edit`;

    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  // how to Group Share

  getHowToGS(): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/how-to-group-share/info`;
    return this.http.get(url);
  }

  updateHowToGS(formData: FormData, data: string): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/how-to-group-share/details`;

    let params: HttpParams = new HttpParams();
    params = params.set('howToGroupShareRequest',data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  addFeaturedGuests(formValue:any, formData: FormData): Observable<any> {
    let url = environment.apiURL + `api/featured-guest/create`;
    delete formValue.image;
    let urlprams = new URLSearchParams(formValue).toString();
    url = url +'?'+ urlprams;
    return this.http.post(url, formData, { responseType: 'text'
  });
}

  updateHowToTickets(formData: FormData, data: string): Observable<any> {
    const url = environment.apiURL + `api/cinejoy/how-to-tickets/details`;

    let params: HttpParams = new HttpParams();
    params = params.set('howToTicketsRequest', data);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text'
    });
  }

  getFeaturedGuestsList(): Observable<any> {
    const url = environment.apiURL + `api/featured-guest/list`;
    return this.http.get(url);
  }

  getFeaturedGuestsListByDate():Observable<any>{
    const url = environment.apiURL + `api/featured-guest/list-by-date`;
    return this.http.get(url);
  }

  getCinejoyHostsList():Observable<any>{
    const url = environment.apiURL + `api/featured-guest/cinejoy-host/list`;
    return this.http.get(url);
  }

  deleteFeaturedGuests(id:any):Observable<any>{
    const url=environment.apiURL+'api/featured-guest/delete/' + id;
    return this.http.delete(url, { responseType: 'text'})
  }

  updateFeaturedGuests(value, formData, id:any):Observable<any>{
    let gt = value.guestType;
    let url = environment.apiURL + `api/featured-guest/update/${id}?guestType=${gt}&updateData=%7B`;
    delete value.image;
    delete value.guestType;
    //let urlprams = new URLSearchParams(value).toString();
    Object.entries(value).map((v, index)=>{
      console.log(Object.entries(value).length)
      url = url + '"' + v[0] + '"' +  ":" + '"' + v[1]+'"';
      if(index < Object.entries(value).length- 1){
        url =  url + ',';
      }
      if(index == Object.entries(value).length- 1){
        url =  url + '%7D';
      }
    })
 //   url = url + urlprams +'%7D';
    return this.http.patch(url, formData, {
      responseType: 'text'
    });
  }

  getMeetCreaticsList(): Observable<any> {
    const url = environment.apiURL + `api/meet-creatics`;
    return this.http.get(url);
  }

  postNotificationsDetails(obj:any):Observable<any>{
    const formData = new FormData();
    formData.append('NotificationTitle', obj.NotificationTitle);
    formData.append('NotificationDesc', obj.NotificationDesc);
    formData.append('Link', obj.Link);
    formData.append('UserId', obj.UserId);
    formData.append('SpecificUsers', obj.SpecificUsers);
    formData.append('Recipients', obj.Recipients);

    const url = environment.apiURL + `api/submitNotification`
    return this.http.post(url, formData, {
      responseType: 'text'
    });
  }

  getNotificationDetailsById(id:any):Observable<any>{
    const url = environment.apiURL + `api/submitNotification/${id}`;
    return this.http.get(url);
  }

  getAllNotificationList():Observable<any>{
    const url = environment.apiURL + `api/submitNotification/list`;
    return this.http.get(url);
  }

  deleteNotificationById(id:any):Observable<any>{
    const url = environment.apiURL + `api/submitNotification/delete/${id}`;
    return this.http.delete(url, {
      responseType: 'text'
    });
  }

  patchNotificationById(id:any,obj:any):Observable<any>{
    const url = environment.apiURL + `api/submitNotification/update/${id}`;

    return this.http.patch(url,obj, {
      responseType: 'text'
    });
  }

  getAllFooterSections():Observable<any>{
    const url = environment.apiURL + `api/footer/sections`;
    return this.http.get(url);
  }

  getAllFooterSectionById(id):Observable<any>{
    const url = environment.apiURL + `api/footer/sections/${id}`;
    return this.http.get(url);
  }

  addFooterSection(data:any): Observable<any> {
    let url = environment.apiURL + `api/footer/submitFooter`;
    if(data.section){
      url += `?section=${data.section}`
    }
    if(data.link){
      url += `&link=${data.link}`
    }
    if(data.description){
      url += `&description=${data.description}`
    }
    return this.http.post(url, {});
  }

  updateFooterSection(data:any): Observable<any> {
    let url = environment.apiURL + `api/footer/updateFooter/${data.id}`;
    if(data.section){
      url += `?section=${data.section}`
    }
    if(data.link){
      url += `&link=${data.link}`
    }
    if(data.description){
      url += `&description=${data.description}`
    }
    return this.http.patch(url, {});
  }

  deleteFooterById(id:any):Observable<any>{
    const url = environment.apiURL + `api/footer/delete/${id}`;
    return this.http.delete(url, {
      responseType: 'text'
    });
  }

  getTerms(): Observable<any> {
    const url = environment.apiURL + 'api/terms/details';
    return this.http.get(url);
  }

  getPrivacy(): Observable<any> {
    const url = environment.apiURL + 'api/privacy/details';
    return this.http.get(url);
  }

  updatePrivacy(data: any): Observable<any> {
    const url = environment.apiURL + `api/privacy/edit`;
    const headers = { 'content-type': 'application/json' };
    return this.http.post(url, data, {
      responseType: 'text',
      headers: headers,
    });
  }

  updateTerms(data: any): Observable<any> {
    const url = environment.apiURL + `api/terms/edit`;
    const headers = { 'content-type': 'application/json' };
    return this.http.post(url, data, {
      responseType: 'text',
      headers: headers,
    });
  }
   //Meet Creatics
   getMeetCreatics(): Observable<any> {
    const url = environment.apiURL + 'api/meet-creatics/details';
    return this.http.get(url);
  }

  updateMeetCreatics(heading, description: any, formData): Observable<any> {
    const url = environment.apiURL + `api/meet-creatics/details/edit`;

    let params: HttpParams = new HttpParams();
    params = params.set('heading', heading);
    params = params.set('description', description);

    return this.http.post(url, formData, {
      params: params,
      responseType: 'text',
    });

  }

  getContestantInfoById(id:any):Observable<any>{
    const url = environment.apiURL + `api/get/contestant/${id}`;
    return this.http.get(url);
  }

  updateContestantById(id: number, updatedData: any, formData: any): Observable<any> {
    const url = environment.apiURL + `api/update/contestant/${id}`;

    let params = new HttpParams();
    params = params.append('contestantVideo', updatedData.videoLink);
    params = params.append('firstName', updatedData.firstName);
    params = params.append('lastname', updatedData.lastName);
    params = params.append('profileDesc', updatedData.bio);
    params = params.append('sequence', updatedData.sequence);

    return this.http.patch(url, formData, { params: params , responseType: 'text' });
  }

  postNewContestPage(userId: number, formData: FormData, data: string): Observable<any> {

   const url = environment.apiURL + `api/users/${userId}/account/addnewcontest`;

   let params: HttpParams = new HttpParams();
   params = params.set('contestRequestDTO', data);
    return this.http.post(url, formData, {
      params: params,
      responseType: 'text',
    });
  }

}


